var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('portal-target',{attrs:{"name":"modal","multiple":""}}),_c('router-view',{attrs:{"name":"header"}}),_c('fade-transition',{attrs:{"origin":"center","mode":"out-in","duration":400}},[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }